import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import { Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Icon } from "@domestika-dev/prudencio/dist/atoms/Icon";
import { UsersNew } from "@domestika-dev/prudencio/dist/atoms/Icons";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography";
import { LiveSessionContext } from "../../../context/LiveSessionContext";

export const ChatHeaderViewers = () => {
  const { connectedUsers } = useContext(LiveSessionContext);
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Icon>
        <UsersNew />
      </Icon>
      <Text size="micro">
        {" "}
        <FormattedMessage
          id="live_sessions.chat.header.viewers"
          values={{ count: connectedUsers }}
        />
      </Text>
    </Flex>
  );
};

export default ChatHeaderViewers;
